/**
 * IDs fixos de agenda de conteúdo → IDs de slots ocupados.
 * Espelha `CONTEUDO_SLOTS` do backend (slotsOcupadosConvidadoService).
 * Conteúdo id 5 ocupa 3 slots (ex.: 10:40, 11:20 e 12:00).
 */
export const CONTEUDO_SLOTS = {
  4: [3, 4],
  5: [7, 8, 9],
};

function normalizarHora(valor) {
  if (!valor) return "";
  const texto = String(valor);
  return texto.length >= 5 ? texto.substring(0, 5) : texto;
}

function normalizarData(valor) {
  if (!valor) return "";
  return String(valor).substring(0, 10);
}

/**
 * Retorna os horários (HH:mm) ocupados por um conteúdo na data,
 * com base nos IDs de slot do mapa CONTEUDO_SLOTS.
 * @returns {string[]|null} horários ou null se o conteúdo não estiver no mapa
 */
export function obterHorariosOcupadosPorConteudo(
  idAgendaConteudo,
  slots = [],
  dataSelecionada = ""
) {
  const idsSlots = CONTEUDO_SLOTS[Number(idAgendaConteudo)];
  if (!idsSlots?.length) return null;

  const dataAlvo = normalizarData(dataSelecionada);
  const setIds = new Set(idsSlots.map(Number));

  return slots
    .filter((slot) => {
      if (!setIds.has(Number(slot.id))) return false;
      if (!dataAlvo) return true;
      return normalizarData(slot.data) === dataAlvo;
    })
    .map((slot) => normalizarHora(slot.horario_inicio || slot.horarioInicio))
    .filter(Boolean);
}

/**
 * Marca no Set os horários ocupados pelo conteúdo.
 * Usa CONTEUDO_SLOTS quando existir; senão fallback início + próximo slot.
 */
export function marcarHorariosConteudo({
  idAgendaConteudo,
  horaInicio,
  slots,
  dataSelecionada,
  horariosDia,
  destinos = [],
}) {
  const horariosMapa = obterHorariosOcupadosPorConteudo(
    idAgendaConteudo,
    slots,
    dataSelecionada
  );

  const aplicar = (hora) => {
    if (!hora) return;
    destinos.forEach((set) => set.add(hora));
  };

  if (horariosMapa?.length) {
    horariosMapa.forEach(aplicar);
    return;
  }

  aplicar(horaInicio);
  const idx = horariosDia.indexOf(horaInicio);
  if (idx >= 0 && idx + 1 < horariosDia.length) {
    aplicar(horariosDia[idx + 1]);
  }
}
